import { fetchMyUplinkStatus, fetchMyWorkshopStatus } from "../../api/queries";

// Single source of truth for "which screen should this person land on,"
// used both right after login/registration and on every app reload with an
// existing session -- so the two never drift apart.
//   admin                   -> AdminWorkshops, always (admin nav picks from there)
//   no mission chosen yet   -> Dashboard (mission chooser)
//   chosen, not in a group  -> WorkshopWaiting (group name + access code)
//   chosen and in a group   -> straight into that group's mission sheet,
//                              or, once the group has submitted its plan,
//                              to the command uplink (or its code screen)
export async function routeAfterAuth(email: string, handlePageChange: (page: string) => void) {
  const { data: status, error } = await fetchMyWorkshopStatus(email);

  if (error || !status) {
    handlePageChange("Dashboard");
    return;
  }

  if (status.role === "admin") {
    handlePageChange("AdminWorkshops");
    return;
  }

  if (!status.chosen_mission_id) {
    handlePageChange("Dashboard");
    return;
  }

  if (!status.access_verified) {
    handlePageChange("WorkshopWaiting");
    return;
  }

  const { data: uplink } = await fetchMyUplinkStatus();
  if (uplink?.plan_submitted) {
    handlePageChange(uplink.uplink_unlocked ? "CommandExecutor" : "UplinkWaiting");
    return;
  }

  handlePageChange("MissionView");
}
